(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              this.initializeSwiper();

              window.addEventListener('resize', this.handleResize.bind(this));
						}
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    initializeSwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      if (window.innerWidth < 750) {
        this.swiper = new Swiper('.product-recommendations--swiper', {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
          navigation: {
            nextEl: '.recommendations_button--next',
            prevEl: '.recommendations_button--prev',
          },
        });
      }
    }

    handleResize() {
      // Реинициализируем слайдер при изменении размера окна
      this.initializeSwiper();
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
